export const FontConfig = {
	display: {
		name: 'Plus Jakarta Sans',
		weights: [600, 800],
	},
	ui: {
		name: 'Inter',
		weights: ['400..700'],
	},
};
